import { useQuery } from "@tanstack/react-query";
import { fetchPortingRecord } from "../actions/fetchPortingRecord.actions";

interface PortingQuery {
    companyId: string | number;
}

export const usePortingQuery = ({ companyId }: PortingQuery) => {
    const portingQuery = useQuery({
        queryKey: ["porting-record", companyId],
        queryFn: () => fetchPortingRecord(companyId),
        enabled: !!companyId,
        retry: false,
    });


    return portingQuery
};
